import { createSelector } from 'reselect';

export const getQuotes = createSelector(
  (state) => state.quotes.data.quotes,
  (quotes) => {
    return quotes;
  }
);

export const getQuotesCount = createSelector(
  (state) => state.quotes.data.quotesCount,
  (quotesCount) => {
    return quotesCount;
  }
);

export const getCurrentPage = createSelector(
  (state) => state.quotes.ui.currentPage,
  (currentPage) => {
    return currentPage;
  }
);

export const getSelectedQuoteIndex = createSelector(
  (state) => state.quotes.ui.selectedQuoteIndex,
  (selectedQuoteIndex) => {
    return selectedQuoteIndex;
  }
);

export const getTaskImages = createSelector(
  (state) => state.quotes.ui.taskImages,
  (taskImages) => {
    return taskImages;
  }
);



// WEBPACK FOOTER //
// ./src/selectors/admin/quotes/quotes.js